import { makeStyles, Avatar } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    icon: {
        fontSize: 24,
        userSelect: 'none',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default
    },
    '@keyframes fadeIn': {
        '0%': {
            opacity: 0,
            transform: 'scale(0.96)',
            filter: 'blur(8px)'
        },
        '100%': {
            opacity: 1,
            transform: 'scale(1)',
            filter: 'blur(0)'
        }
    },
    animate: {
        animation: '$fadeIn 150ms ease-out forwards'
    }
}));

const ImageAvatar = ({ alt = '', src, className, variant = 'rounded', children }) => {
    const classes = useStyles();

    return (
        <Avatar
            alt={alt}
            src={src}
            variant={variant}
            className={clsx(classes.icon, !src ? null : classes.animate, className)}
        >
            {children}
        </Avatar>
    );
};

export default ImageAvatar;
